import { Button } from "@material-ui/core";
import { Launch } from "@material-ui/icons";
import { memo } from "react";
import { utils, writeFile } from "xlsx";
import { xlsxGroupEmptyDescription } from "../../constants";
import { useRankingClienteService } from "../context/RankingClienteContext";

const ExportButton = ({ data, filename }) => {
  const { columns, isGrouped } = useRankingClienteService();
  const isDisabled = !data?.length;

  const exportToXLSX = () => {
    const rows = [];
    const headersIds = {};

    const header = [
      "",
      ...columns.map((colum) => {
        headersIds[colum.id] = colum.id;
        return colum.label;
      }),
    ];

    rows.push(header);

    data.forEach((cell) => {
      const formattedData =
        cell.customers?.map((customer) => ({
          ...customer,
          company: `${customer.company.id} - ${customer.company.description}`,
        })) ?? [];
      if (isGrouped)
        rows.push([
          cell.group?.description ??
            xlsxGroupEmptyDescription[cell.group?.type],
        ]);

      formattedData.forEach((item) => {
        const row = [
          "",
          ...columns.map((column) =>
            column?.format ? column.format(item[column.id]) : item[column.id]
          ),
        ];
        rows.push(row);
      });

      const totalsLabel = "Totais: ";

      const totals = columns.map((column) => {
        return [
          "originalAmount",
          "increase",
          "discount",
          "netValue",
          "finishedAmount",
        ].includes(column.id)
          ? cell.total[column.id]
          : "";
      });

      rows.push([totalsLabel, ...totals]);
    });

    const sheet = utils.aoa_to_sheet(rows);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, sheet, "Sheet1");
    writeFile(workbook, `${filename}.xlsx`);
  };

  return (
    <Button
      size="small"
      variant="contained"
      endIcon={<Launch />}
      style={
        isDisabled
          ? null
          : {
              backgroundColor: "#1d6f42",
              color: "#f4f4f4",
            }
      }
      onClick={exportToXLSX}
      disabled={isDisabled}
    >
      XLSX
    </Button>
  );
};

export default memo(ExportButton);
